import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Configurations } from '../../../../Utils/Configurations';
//import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ErrorModal from '../../../../Components/ErrorModal/ErrorModal';
import ModalAlteracoes from '../../../../Components/Modal-Alteracoes/Modal-Alteracoes';
import VideoPlaylistItems from '../../../../Components/Playlist/Videos/VideoPlaylistItems';
import InsertVideo from '../../../../Components/Insert-Video/Insert-Video';
//import Pagination from 'rc-pagination';
import { withRouter } from 'react-router-dom';
import ImagemFukyo from '../../../../Components/Imagem-Fukyo/Imagem-Fukyo';

const VideoPlaylistDetails = (props) => {

    const idPlaylist = props.match && props.match.params && props.match.params.idPlaylist;

    const [playlistData, setPlaylistData] = useState({})
    const [formState, setFormState] = useState({ nomePlaylist: '', categoria: '', imagem: '' })
    const [playlists, setPlaylists] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadingPlaylist, setLoadingPlaylist] = useState(true)
    //const [loadingStatusPlaylist, setLoadingStatusPlaylist] = useState(false)
    const [temAlteracao, setTemAlteracao] = useState(false)
    const [sucessoAlteracao, setSucessoAlteracao] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [modalAlteracoes, setModalAlteracoes] = useState(false)
    const [modalVideo, setModalVideo] = useState(false)
    //const [pagina, setPagina] = useState(1)
    //const [limite, setLimite] = useState(10)
    //const [paginasPlaylists, setPaginasPlaylists] = useState(1)
    const [newImage, setNewImage] = useState(null)
    const [imageName, setImageName] = useState('')
    const [temArquivo, setTemArquivo] = useState(false)
    //const [arquivoSalvo, setArquivoSalvo] = useState(false)
    const [loadingSalvar, setLoadingSalvar] = useState(false)

    // const inicializaParametros = () => {
    //     const values = qs.parse(window.location.search)
    //     const limiteUrl = parseInt(values.limite, 10) || 10
    //     const paginaUrl = parseInt(values["?pagina"], 10) || 1

    //     //setPagina(paginaUrl)
    //     //setLimite(limiteUrl)
    // }

    const carregaEpisodios = () => {
        setLoading(true)
        //const values = qs.parse(window.location.search)
        // const limiteUrl = parseInt(values.limite, 10) || 10
        // const paginaUrl = parseInt(values["?pagina"], 10) || 1

        const config = new Configurations()
        axios.get(config.apiBasePath + `/playlist/video/${idPlaylist}/item`)
            .then(response => {
                setPlaylists(response.data.data.itens)
                //setPaginasPlaylists(response.data.data.paginacao.totalPaginas)
            })
            .catch(error => {
                console.log("ERROR: ", error)
                handleError(error)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const novaPlaylist = () => {
        setLoadingPlaylist(true)
        const body = {
            nomePlaylist: formState.nomePlaylist,
            image: formState.imagem,
            visibilidade: 'public',
            escopo: 'global',
            categoria: 'Destaques para você'
        }
        const config = new Configurations()
        axios.post(config.apiBasePath + `/playlist/video/`, body)
            .then(response => {
                setSucessoAlteracao(true)
                setTemAlteracao(false)
                props.history.push({
                    pathname: `${response.data.data.id}`
                })
            })
            .catch(error => {
                console.log("ERROR: ", error)
                handleError(error)
            })
            .finally(() => {
                setLoadingPlaylist(false)
            })
    }

    const carregaInfosPlaylist = (idPlaylistParam) => {
        setLoadingPlaylist(true)
        const config = new Configurations()
        axios.get(config.apiBasePath + `/playlist/video/${idPlaylistParam}`)
            .then(response => {
                const _playlist = response.data.data
                setPlaylistData(_playlist)
                setFormState({
                    nomePlaylist: _playlist.nomePlaylist,
                    categoria: _playlist.categoria,
                    imagem: _playlist.image
                })
                setLoading(false)
            })
            .catch(error => {
                console.log("ERROR: ", error)
                handleError(error)
            })
            .finally(() => {
                setLoadingPlaylist(false)
            })
    }

    const salvarPlaylist = () => {
        setLoadingPlaylist(true)
        const _salvarPlaylist = {
            nomePlaylist: formState.nomePlaylist,
            image: formState.imagem,
            ativo: true,
        }
        const config = new Configurations()
        axios.put(config.apiBasePath + `/playlist/video/${idPlaylist}`, _salvarPlaylist)
            .then(response => {
                console.log("🚀 ~ salvarPlaylist ~ response:", response.data)
                setSucessoAlteracao(true)
                setTemAlteracao(false)
                carregaInfosPlaylist(idPlaylist)
            })
            .catch(error => {
                console.log("ERROR: ", error)
                handleError(error)
            })
            .finally(() => {
                setLoadingPlaylist(false)
            })
    }

    // const mudaStatusPlaylist = () => {
    //     const config = new Configurations()
    //     axios.put(config.apiBasePath + `/playlists-videos/${idPlaylist}/${metodoStatusPublicacao}`)
    //         .then(response => {
    //             carregaInfosPlaylist(idPlaylist)
    //         })
    //         .catch(error => {
    //             console.log("ERROR: ", error)
    //             handleError(error)
    //         })
    //         .finally(() => {
    //             toggleStatusPublicacao()
    //         })
    // }

    const handleEdit = (e) => {
        const { name, value } = e.target
        const newFormState = { ...formState, [name]: value }
        setFormState(newFormState)

        setTemAlteracao(
            newFormState.nomePlaylist !== playlistData.nomePlaylist ||
            newFormState.categoria !== playlistData.categoria
        )
    }

    const handleEditImageName = (e) => {
        setImageName(e.target.value)
    }

    const onSelectFileImage = (e) => {
        setNewImage(e.target.files[0])
        setTemArquivo(true)
    }

    const salvarImg = async () => {

        //verificar caminho da API e pasta que imagem será salva
        const config = new Configurations();
        var bodyFormData = new FormData();
        bodyFormData.append('imagem', newImage);
        bodyFormData.append('tipo', 'video');
        const nomeComTimestamp = `${imageName}-${Date.now()}`;
        bodyFormData.append('nomeImagem', nomeComTimestamp);

        setLoadingSalvar(true)

        await axios.post(config.apiBasePath + `/playlist/capa/upload`, bodyFormData).then(response => {
            console.log("🚀 ~ salvarImg ~ response:", response)

            setFormState((prevState) => ({
                ...prevState,
                imagem: response.data.image,
            }));

            setLoadingSalvar(false)

            // setArquivoSalvo(true)

            // if (youtube) { setModalSuccessYoutube(true) }
        }).catch(err => {
            console.log("ERROR:", err)
            setLoadingSalvar(false)
        });
    }

    const adicionarVideo = (programa, episodio) => {
        const body = {
            idVideoPrograma: programa,
            idVideoEpsodio: episodio
        }

        const config = new Configurations()
        axios.post(config.apiBasePath + `/playlist/video/${idPlaylist}/item`, body)
            .then(response => {
                console.log("🚀 ~ adicionarVideo ~ response:", response.data)
                carregaEpisodios()
            })
            .catch(error => {
                console.log("ERROR: ", error)
                handleError(error)
            })
            .finally(() => {
            })
    }

    const handleError = (err) => {
        setHasError(true)
        setErrorMessage(err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Erro desconhecido')
    }

    const closeErrorModal = () => {
        setHasError(false)
        setErrorMessage("")
    }

    const toggleModalAlteracoes = () => {
        setModalAlteracoes(!modalAlteracoes)
    }


    const toggleModalVideo = () => {
        setModalVideo(!modalVideo)
    }

    // const confirmaStatusPublicacao = (metodo) => {
    //     toggleStatusPublicacao()
    //     setMetodoStatusPublicacao(metodo)
    // }

    const handleModalVideo = ({ idProg, idEp, nomeEp }) => {

        adicionarVideo(idProg, idEp)
        toggleModalVideo()
    }

    const voltar = () => {
        if (temAlteracao) {
            toggleModalAlteracoes()
        } else {
            window.history.go(-1)
        }
    }

    // const onChangePage = (page) => {
    //     setPagina(page)
    //     props.history.push({
    //         pathname: `/multimidia/playlists/${idPlaylist}`,
    //         search: `?pagina=${page}&limite=${limite}`
    //     })
    // }

    useEffect(() => {
        if (idPlaylist === 'novo') {
            setLoading(false)
            setLoadingPlaylist(false)
            return
        }
        carregaInfosPlaylist(idPlaylist)
        carregaEpisodios()
    }, [])

    return (
        <div className="row episodes-list">
            <div className="col-12">
                {loading || loadingPlaylist ? (
                    <div className="row no-gutters">
                        <div className="col-12 text-center py-5">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    </div>
                ) : (
                    <div className="row no-gutters">
                        <div className="col-12">
                            <div className="row no-gutters align-items-center">
                                <div className="col-12 col-lg-8 text-center text-lg-left">
                                    <h2 className="title-1 d-none d-lg-block">Playlists - {idPlaylist === 'novo' ? 'Nova Playlist' : playlistData.nomePlaylist}</h2>
                                    <h5 className="d-lg-none">{playlistData.nomePlaylist}</h5>
                                </div>
                                <div className="col-12 col-lg-4 text-center text-lg-right">
                                    <div className="row no-gutters">
                                        <div className="col py-2 py-lg-0">
                                            <button onClick={voltar} className="btn btn-outline-secondary">voltar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {loadingPlaylist ? (
                                <div className="row no-gutters">
                                    <div className="col-12 text-center py-5">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                </div>
                            ) : (
                                <div className="card rounded my-2">
                                    <div className="card-header">
                                        <p className="m-0">Informações da Playlist</p>
                                    </div>
                                    <div className="card-body">
                                        <div className="row no-gutters ">
                                            <div className="col-12 col-lg-6">
                                                <fieldset disabled={false}>
                                                    <div className="row no-gutters">
                                                        <div className="col-12 px-1 py-1">
                                                            <label>Nome da playlist</label>
                                                            <input autoComplete="off" name="nomePlaylist" className="form-control input-edicao" type="text" value={formState.nomePlaylist} onChange={handleEdit} />
                                                        </div>
                                                        <div className="col-12 px-1 py-2">
                                                            <label>Imagem de capa</label>
                                                            <input name="image" className="pt-2 ml-4" type="file" accept='.jpg,.jpeg,.png' onChange={onSelectFileImage} />

                                                            {temArquivo && (
                                                                <>
                                                                    <p className='mb-0 mt-2'>Nome da imagem</p>
                                                                    <small className='form-text text-muted'>
                                                                        Usar traço (-) para fazer a separação das palavras
                                                                    </small>
                                                                    <input autoComplete="off" name="imageName" className="form-control input-edicao my-3" type="text" value={imageName} onChange={handleEditImageName} />
                                                                    <div className='d-flex justify-content-end'>
                                                                        {loadingSalvar ? (
                                                                            <div className="spinner-border text-success" role="status" />
                                                                        ) :
                                                                            <button className='btn btn-outline-success' onClick={() => salvarImg()}>Salvar imagem</button>}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <div className="row no-gutters">
                                                    <div className="col-12 py-1">
                                                        <div className="row no-gutters align-items-center">
                                                            <div className="offset-lg-2 col-lg-8 col-12 text-center py-3">
                                                                <ImagemFukyo
                                                                    className={`img img-fluid`}
                                                                    src={formState.imagem}
                                                                    alt={`imagem-playlist`}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-12 py-3 text-center text-lg-right">
                                                {loadingPlaylist ? (
                                                    <div className="spinner-border text-primary" role="status" />
                                                ) : (
                                                    <>
                                                        {sucessoAlteracao && !temAlteracao && (
                                                            <span className="text-success mr-3"><i>Alterações salvas com sucesso.</i></span>
                                                        )}
                                                        {temAlteracao && (
                                                            <span className="text-danger mr-3"><i>As alterações ainda não foram salvas.</i></span>
                                                        )}
                                                        {/* disabled={formState.nomePlaylist.trim() === '' || !temAlteracao} */}
                                                        <button onClick={() => idPlaylist === 'novo' ? novaPlaylist() : salvarPlaylist()} className="btn btn-outline-success">salvar {idPlaylist === 'novo' ? '' : 'alterações'}</button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {idPlaylist !== 'novo' && (
                                <div className="row no-gutters">
                                    <div className="col-12 pt-4 pb-3 text-center">
                                        <h5 className="m-0">Lista de vídeos</h5>
                                    </div>
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row no-gutters align-items-center pb-lg-3">
                                                    <div className="col-12 pb-3 py-lg-2 text-center">
                                                        <button onClick={() => toggleModalVideo()} className="btn btn-outline-success">adicionar vídeo</button>
                                                    </div>
                                                </div>
                                                {loading ? (
                                                    <div className="col-12 text-center px-3 py-5">
                                                        <div className="spinner-border text-primary" role="status" />
                                                    </div>
                                                ) : (
                                                    <div className="col-12">
                                                        <div className="row lista-episodios">
                                                            {playlists && playlists.map((item, index) => {
                                                                return (
                                                                    <div className="col-12 py-2" key={index}>
                                                                        <VideoPlaylistItems
                                                                            item={item}
                                                                            history={props.history}
                                                                            match={props.match}
                                                                            carregaEpisodios={carregaEpisodios}
                                                                            idPlaylist={idPlaylist}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* {!loading && playlists && playlists.length > 0 && (
                                    <div className="col-12 mt-2 px-0">
                                        <div className="paginacao-episodios">
                                            <Pagination onChange={onChangePage} current={pagina} total={paginasPlaylists * limite} pageSize={limite} />
                                        </div>
                                    </div>
                                )} */}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* <Modal isOpen={modalStatusPublicacao} toggle={toggleStatusPublicacao}>
                <ModalHeader toggle={toggleStatusPublicacao}>Mudança de Status da Playlist</ModalHeader>
                <ModalBody>
                    {metodoStatusPublicacao === 'habilitar' ? (
                        <p className="m-0">{`Deseja confirmar a habilitação da playlist ${formState.nomePlaylist}?`}</p>
                    ) : (
                        <p className="m-0">{`Deseja desabilitar a playlist ${formState.nomePlaylist}?`}</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    {loadingStatusPlaylist ? (
                        <div className="spinner-border text-primary" role="status" />
                    ) : (
                        <Button disabled={loadingStatusPlaylist} color={`${metodoStatusPublicacao === 'habilitar' ? `success` : `danger`}`} onClick={mudaStatusPlaylist}>confirmar</Button>
                    )}
                    {' '}<Button color="secondary" onClick={toggleStatusPublicacao}>voltar</Button>
                </ModalFooter>
            </Modal> */}

            <ErrorModal
                isOpen={hasError}
                message={errorMessage}
                closeErrorModal={closeErrorModal}
            />

            <ModalAlteracoes
                isOpen={modalAlteracoes}
                toggle={toggleModalAlteracoes}
            />

            <InsertVideo
                isOpen={modalVideo}
                toggle={toggleModalVideo}
                handleModalVideo={handleModalVideo}
            />
        </div>
    )
}

export default withRouter(VideoPlaylistDetails);
